export default {
  restaurant: 'Restaurante',
  bar: 'Bar',
  hotel: 'Hotel',
  museum: 'Museo',
  cultureHouse: 'Centro Cultural',
  park: 'Parque',
  gym: 'Gimnasio',
  comercialCenter: 'Centro Comercial',
  theatre: 'Teatro',
  cafe: 'Cafe',
  library: 'Biblioteca',
  house: 'Casa',
  assistantsExportedSuccessfully: 'Asistentes exportados correctamente',
  createEvent: 'Crear evento',
  mustChargeBeforeCreateEvents: 'Debes recargar dinero antes de crear eventos',
  events: 'Eventos',
  published: 'Publicado',
  notPublished: 'Sin publicar',
  soldOut: 'Agotado',
  publishEventToBeShownInSalesLists: 'Publique este evento para que se muestre en los listados de venta',
  loadingEvents: 'Cargando eventos',
  noEventsRegistered: 'No hay eventos registrados',
  publish: 'Publicar',
  soldTickets: 'Boletas vendidas',
  availableTickets: 'Boletas disponibles',
  totalTickets: 'Total de boletas',
  eventStateUpdated: 'Estado del evento actualizado',
  profileImage: 'Imagen de perfil',
  thePicture: 'La foto',
  thePictures: 'Las fotos',
  theMiniatures: 'Las miniaturas',
  theBanner: 'El banner',
  /* Promotors */
  createPromotor: 'Crear promotor',
  mustChargeBeforeCreatingPromotors: 'Debes recargar dinero antes de crear promotores',
  promotors: 'Promotores',
  showUrlToPromotor: 'Mostrar url al promotor',
  editPromotor: 'Editar promotor',
  setProfilePicture: 'Establecer foto de perfil',
  setBanner: 'Establecer banner',
  deletePromotor: 'Borrar promotor',
  loadingPromotor: 'Cargando promotores',
  noPromotorsRegistered: 'No hay promotores registrados',
  /* End Promotors */
  /* Products */
  price: 'Precio',
  discountPrice: 'Precio de descuento',
  stock: 'Inventario',
  createProduct: 'Crear producto',
  mustChargeBeforeCreatingProducts: 'Debes recargar dinero antes de crear productos',
  products: 'Productos',
  newProduct: 'Crear Producto',
  editProduct: 'Editar producto',
  photos: 'Fotos',
  setProductPhoto: 'Subir Foto del Producto',
  miniaturePhotos: 'Fotos en Miniatura',
  setProductMiniaturePhoto: 'Subir Foto en miniatura del Producto',
  deleteProduct: 'Eliminar producto',
  loadingProduct: 'Cargando productos',
  noProductsRegistered: 'No hay productos registrados',
  doYouWantToDeleteProduct: '¿Desea borrar el producto?',
  /* End Products */
  /* Purchase Products */
  shippingAddress: 'Dirección de envío',
  payAmount: 'Monto del pago',
  paymentDate: 'Fecha de pago',
  productPurchases: 'Compras de Productos',
  newProductPurchase: 'New Product Purchase',
  viewProductPurchase: 'Visualizar la Compra del Producto',
  editProductPurchase: 'Edit product purchase',
  deleteProductPurchase: 'Delete product purchase',
  loadingProductPurchase: 'Loading product purchases',
  noProductPurchasesRegistered: 'There aren\'t product purchases registered',
  doYouWantToDeleteProductPurchase: 'Do you want to delete the product purchase?',
  /* End Purchase Products */
  provider: 'Proveedor',
  providers: 'Proveedores',
  createProvider: 'Crear proveedor',
  mustChargeBeforeCreatingProviders: 'Debes recargar dinero antes de crear proveedores',
  newProvider: 'Crear Proveedor',
  editProvider: 'Editar proveedor',
  deleteProvider: 'Eliminar proveedor',
  loadingProvider: 'Cargando proveedores',
  noProvidersRegistered: 'No hay proveedores registrados',
  doYouWantToDeleteProvider: '¿Desea borrar el proveedor?',
  providerHasBeenDeleted: 'El proveedor ha sido borrado',
  fabric: 'Fábrica',
  fibre: 'Fibra',
  key: 'Llave',
  positionArc: 'Posición Arc',
  acab: 'Acab',
  acabado: 'Acabado',
  refChina: 'Referencia China',
  refClient: 'Referencia Cliente',
  label: 'Label',
  wide: 'Wide',
  weight: 'Weight',
  composition: 'Composition',
  perfomance: 'Perfomance',
  unitMeasure: 'Unit Measure',
  cantMtsFinals: 'cant Mts Finals',
  cantKlsFinals: 'cant Kls Finals',
  cantMtKl: 'cant Mt Kl',
  capMaxKl: 'cap Max Kl',
  portOcupation: 'port Ocupation',
  // newProduct: 'Nuevo producto',
  // editProduct: 'Editar producto',
  // deleteProduct: 'Eliminar producto',
  // loadingProduct: 'Cargando productos',
  // noProductsRegistered: 'No hay productos registrados',
  // doYouWantToDeleteProduct: '¿Desea borrar el producto?'
  productHasBeenDeleted: 'El producto ha sido borrado',
  attachEventsInYourWebSite: 'Insertar Eventos en tu página web',
  createDivElementToAttachEventsInYourWebSite: 'Para insertar Eventos a tu página web, debes crear un elemento DIV con el ID',
  andOtherWithTheId: 'y otro con el ID',
  inYourSiteBody: 'en la etiqueta body de tu sitio',
  andThenAddTheNextScriptInTheFooter: 'Y luego agregar el siguiente Script en el Footer de tu sitio',
  scriptCopied: 'Script copiado',
  errorCopyingTheScript: 'Error al copiar el script',
  exportAssistants: 'Exportar asistentes',
  assistantsList: 'Lista de asistentes',
  assistantId: 'Id del asistente',
  loadingAssistants: 'Cargando asistentes',
  noAssistantsRegistered: 'No hay asistentes registrados',
  registerDate: 'Fecha de registro',
  automatic: 'Automática',
  manual: 'Manual',
  creationType: 'Tipo de creación',
  errorLoadingEvent: 'Ocurrió un error cargando el evento',
  eventNotPublishedAndOutOfLists: 'Tu evento se encuentra sin publicar, por lo que no se va a mostrar en los listados',
  eventDate: 'Fecha del evento',
  publishEvent: 'Publicar evento',
  seePromotorInYourWebSite: 'Visualizar el promotor en tu página web',
  mustDoToSeePromotorInWebSite: 'Para visualizar el promotor, debes asegurarte de tener el widget de eventos en tu página web, para así ingresar a la siguiente url',
  copy: 'Copiar',
  mustContactSupportToSeePromotorInWebSite: 'Para visualizar el promotor, debes contactar con soporte para así obtener una url',
  errorCopyingUrl: 'Error al copiar la url',
  urlCopied: 'Url copiada',
  eventContacts: 'Contactos del evento',
  doYouWantToDeletePromotor: '¿Desea borrar el promotor?',
  /* Djs */
  view: 'Ver',
  djSuccessfullyCreated: 'Dj creado correctamente',
  djSuccessfullyUpdated: 'Dj actualizado correctamente',
  createDj: 'Crear dj',
  mustChargeBeforeCreatingDjs: 'Debes cargar tu cuenta antes de crear Djs',
  djs: 'Djs',
  followers: 'Seguidores',
  showUrlToDj: 'Mostrar la url al dj',
  editDj: 'Editar dj',
  deleteDj: 'Borrar dj',
  loadingDj: 'Cargando djs',
  noDjsRegistered: 'No hay djs registrados',
  doYouWantToDeleteDj: '¿Desea borrar el Dj?',
  seeDjInYourWebSite: 'Ver el dj en tu website',
  mustDoToSeeDjInWebSite: 'Para ver el Dj, debes estar seguro de tener el widget de eventos insertado en tu website, da click en la siguiente url',
  mustContactSupportToSeeDjInWebSite: 'Para ver el Dj, debes contactar a soporte para ver la url',
  /* End Djs */
  importAssistants: 'Importar asistentes',
  event: 'Evento',
  assistantsImportedSuccessfully: 'Asistentes importados correctamente',
  format: 'Formato',
  editEvent: 'Editar evento',
  newEvent: 'Nuevo evento',
  shortDescription: 'Descripción corta',
  note: 'Nota',
  insertNoteToSendInConfirmationEmail: 'Ingrese una nota que se enviará en el correo de confirmación aquí',
  isAnOnlineEvent: 'Es un evento online',
  eventUrl: 'Url del evento',
  category: 'Categoría',
  startDate: 'Fecha de inicio',
  finishDate: 'Fecha de finalización',

  place: 'Lugar',
  places: 'Lugares',
  placeLocation: 'Locación del lugar',
  cantFindPlace: 'No encuentras un lugar? Registra uno.',
  canFindPlace: 'Algun lugar en mente? Selecciona uno.',
  mustChargeBeforeCreatingPlaces: 'Debes recargar dinero antes de crear lugares',
  newPlace: 'Crear lugar',
  editPlace: 'Editar lugar',
  viewPlace: 'Ver lugar',
  setPlacePhoto: 'Subir Foto del lugar',
  deletePlace: 'Eliminar lugar',
  loadingPlace: 'Cargando lugares',
  noPlacesRegistered: 'No hay lugares registrados',
  doYouWantToDeletePlace: '¿Desea borrar el lugar?',
  infoPlace: 'Información del lugar',
  placeSocialNetworks: 'Redes sociales del lugar',
  placeContacts: 'Contactos del lugar',
  ExpAndOffs: 'Experiencias y ofrecimientos',
  experiences: 'Experiencias',
  trips: 'Viajes',
  concerts: 'Conciertos',
  offerings: 'Ofrecimientos',
  veggie: 'Vegetariano',
  allergies: 'Alergias',

  latitude: 'Latitud',
  longitude: 'Longitud',
  organizer: 'Organizador',
  limitRegisterByIdentificationDocument: 'Limitar registro por documento de identificación',
  cover: 'Carátula',
  pictures: 'Fotos | Foto',
  eventCreated: 'Evento creado',
  promotor: 'Promotor',
  locationUrl: 'Url a la localización',
  facebookMessageSendingUrl: 'Facebook Url de envío de mensaje',
  facebookSiteUrl: 'Url del sitio de Facebook',
  completeRequiredFields: 'Complete los campos requeridos',
  promotorSuccessfullyCreated: 'Promotor creado correctamente',
  promotorSuccessfullyUpdated: 'Promotor actualizado correctamente',
  eventSocialNetworks: 'Redes sociales del evento',
  socialNetworkSelect: 'Seleccione la red',
  doYouWantDuplicate: '¿Desea duplicar este lugar?',
  isPlaceActive: '¿Está este lugar activo?',
  configPlace: 'Configuración del lugar',
  placeTags: 'Tags de tu lugar',
  tagsHint: 'Escriba un tag, luego presione Enter',
  pleaseTypeLocation: 'Por favor, escriba su dirección',

  eventTypeCamping: 'Acampada, viaje o retiro',
  eventTypeAttraction: 'Atracción',
  eventTypeRace: 'Carrera o evento de resistencia',
  eventTypeDinner: 'Cena o gala',
  eventTypeWorkshop: 'Clase, curso o taller',
  eventTypeSignature: 'Comparecencia o firma',
  eventTypeConcert: 'Concierto o actuación',
  eventTypeConference: 'Conferencia',
  eventTypeConvention: 'Convención',
  eventTypeMeetup: 'Encuentro o evento de red',
  eventTypeFair: 'Feria comercial, feria de consumo o exposición',
  eventTypeFestival: 'Festival o feria',
  eventTypeParty: 'Fiesta o reunión social',
  eventTypeCompetition: 'Juego o competición',
  eventTypeOther: 'Otro',
  eventTypeProjection: 'Proyección',
  eventTypeRally: 'Rally',
  eventTypeSeminar: 'Seminario o charla',
  eventTypeTournament: 'Torneo',
  eventTypeVisit: 'Visita',

  eventCategoryAcademic: 'Actividades escolares',
  eventCategoryHobbies: 'Aficiones e intereses especiales',
  eventCategoryArts: 'Artes escénicas y visuales',
  eventCategoryScience: 'Ciencia y tecnología',
  eventCategoryCinema: 'Cine, medios de comunicación y entretenimiento',
  eventCategoryCars: 'Coches, barcos y aviones',
  eventCategoryCommunities: 'Comunidad y cultura',
  eventCategorySports: 'Deportes y salud',
  eventCategoryHolidays: 'Días de fiesta',
  eventCategoryFamily: 'Familia y educación',
  eventCategoryGastronomy: 'Gastronomía',
  eventCategoryPolitics: 'Gobierno y política',
  eventCategoryHousing: 'Hogar y estilo de vida',
  eventCategoryFashion: 'Moda y belleza',
  eventCategoryMusic: 'Música',
  eventCategoryBusiness: 'Negocios y servicios profesionales',
  eventCategorySocial: 'Organizaciones y causas benéficas',
  eventCategoryOther: 'Otro',
  eventCategoryReligion: 'Religión y espiritualidad',
  eventCategoryHealth: 'Salud y bienestar',
  eventCategoryOutdoors: 'Viajes y actividades al aire libre',

  urlOrLink: 'URL o enlace',
  socialNetworkAdd: 'Adañir red social',
  eventCurrency: 'Divisa a usar en el evento',
  ticketTitle: 'Título de la boleta',
  ticketPrice: 'Precio de la boleta',
  ticketingServicePrice: 'Valor del servicio de venta de la boleta',
  startOfSale: 'Inicio de la venta',
  endOfSale: 'Finalización de la venta',
  ticketsNumber: 'Cantidad de boletas',
  maxTicketsPerPerson: 'Cantidad máxima de boletas por persona',
  deleteTicket: 'Borrar boleta',
  addTicket: 'Agregar boleta',
  result: 'Resultado',
  ofPromoter: 'del promotor',
  upload: 'Sube',
  allowedFormats: 'Sólo se permiten los formatos',
  maxPictureSize: 'La foto debe ser de máximo',
  and: 'y',
  dragAndDropFile: 'Arrastra y suelta el archivo en esta zona',
  imageSuccessfullyLoaded: 'Tu imagen fue cargada con éxito',
  deleteSelection: 'Eliminar Selección',
  analyze: 'Analizar',
  atLeastOneFileToContinue: 'Ingresa por lo menos un archivo para continuar',
  nextStep: 'Siguiente paso',
  theFile: 'El archivo',
  notAccepted: 'no fue aceptado',
  seeEvent: 'Ver evento',
  registerAttender: 'Registrar asistente',
  advancedSearch: 'Búsqueda avanzada',
  assistantsPerPage: 'Asistentes por página',
  assistantName: 'Nombre del asistente',
  creation: 'Creación',
  ticket: 'Boleta',
  register: 'Registrar',
  assistantRegistered: 'Asistente Registrado',
  buyer: 'Comprador',
  cost: 'Costo',
  parallelAnswer: 'Respuesta Paralela',
  franchise: 'Franquicia',
  bank: 'Banco',
  ofPurchase: 'de la compra',
  download: 'Descargar',
  dataCopied: 'Datos copiados',
  errorTryAgain: 'Ocurrió un error, intente nuevamente',
  checkInState: 'Esatado del Check-In',
  check: 'Chequeado',
  unCheck: 'Sin chequear'
}
